import { GameTagType } from "entities/tagTypes/types";
import {
  useGameTagsData,
  GameTagOption,
} from "modules/games/widgets/GameDetails/stores/useGameTagsData";
import { FC } from "react";
import ContentSection from "shared/components/Drawer/components/ContentSection";
import { useShallow } from "zustand/react/shallow";
import { useServiceTagsOptions } from "../../hooks/useServiceTagsOptions";
import { useThemeTagsOptions } from "../../hooks/useThemeTagsOptions";
import GameTagGroup from "../GameTagGroup";
import { tagTypeOptions } from "../GameTagGroup/constants";

type Props = {
  id: string;
  primaryTagId: string | null;
  selectedTags: GameTagOption[];
  deletable: boolean;
};

const TagTypeItem: FC<Props> = ({
  id,
  primaryTagId,
  selectedTags,
  deletable,
}) => {
  const {
    gameTagTypeBlocks,
    deleteGameTagTypeBlock,
    changeGameTagType,
    changeGameTagPrimaryTag,
    changeGameTagTags,
  } = useGameTagsData(
    useShallow((state) => ({
      gameTagTypeBlocks: state.gameTagTypeBlocks,
      deleteGameTagTypeBlock: state.deleteGameTagTypeBlock,
      changeGameTagType: state.changeGameTagType,
      changeGameTagPrimaryTag: state.changeGameTagPrimaryTag,
      changeGameTagTags: state.changeGameTagTags,
    })),
  );

  const { servicePrimaryTagOptions, secondaryServiceTags } =
    useServiceTagsOptions({
      id,
      primaryTagId,
      tagBlocks: gameTagTypeBlocks,
    });

  const { themePrimaryTagOptions, secondaryThemeTags } = useThemeTagsOptions({
    id,
    primaryTagId,
    tagBlocks: gameTagTypeBlocks,
  });

  const tagType =
    gameTagTypeBlocks.find((block) => block.id === id)?.tagType || null;

  const handleChangeTagType = (tagTypeId: GameTagType) => {
    changeGameTagType(id, tagTypeId);
  };

  const handleChangeTags = (newTags: GameTagOption[]) => {
    changeGameTagTags(id, newTags);
  };

  const handleDeleteTagBlock = () => {
    deleteGameTagTypeBlock(id);
  };

  const handleChangePrimaryTag = (primaryTagId: string) => {
    changeGameTagPrimaryTag(id, primaryTagId);
  };

  const primaryOptions = {
    [GameTagType.SERVICE]: servicePrimaryTagOptions,
    [GameTagType.THEME]: themePrimaryTagOptions,
  };

  const secondaryOptions = {
    [GameTagType.SERVICE]: secondaryServiceTags,
    [GameTagType.THEME]: secondaryThemeTags,
  };
  return (
    <ContentSection>
      <GameTagGroup
        selectedTagType={tagType}
        selectedPrimaryTagId={primaryTagId}
        tagTypeOptions={tagTypeOptions}
        selectedTags={selectedTags}
        secondaryTagOptions={secondaryOptions[tagType ?? GameTagType.SERVICE]}
        onChangePrimaryTag={handleChangePrimaryTag}
        onDeleteTagBlock={handleDeleteTagBlock}
        onSecondaryTagsChange={handleChangeTags}
        primaryTagOptions={primaryOptions[tagType ?? GameTagType.SERVICE]}
        onTagTypeChange={handleChangeTagType}
        deletable={deletable}
      />
    </ContentSection>
  );
};

export default TagTypeItem;
